// Tells the host when their Twitch chat blocked one of Poppy's links.

import { useEffect } from 'react';
import { toast } from 'sonner';
import { twitchStaticConfig } from '@airhead-games/shared/configs';
import { AccountServerMessageType } from '@airhead-games/shared/types';
import { useAccountSocket } from './useAccountSocket';

export function usePoppyChatLinkBlockedToast(): void {
  const { subscribe } = useAccountSocket();

  useEffect(
    () =>
      subscribe((message) => {
        if (message.type !== AccountServerMessageType.POPPY_CHAT_LINK_BLOCKED) {
          return;
        }
        toast.warning("Twitch chat blocked Poppy's link.", {
          description: `Type "/mod ${twitchStaticConfig.botLogin}" in your chat.`,
        });
      }),
    [subscribe]
  );
}
